<app-header-modal-layout
  [headerTitle]="'Load Simulation'"
  [headerColor]="'#000090'"
  [footerSubmitText]="'Load'"
  [footerCancelText]="'Cancel'"
  [footerSubmitColor]="'#000090'"
  [modalSize]="'XL'"
  [footerSubmitDisabled]="(selectedSimulation$ | async) == null"
  (close)="onClose()"
  (submit)="loadSimulation()"
>
  <app-load-simulation-filter
    [users]="users"
    [userId]="userId"
    [userName]="userName"
    [customers]="customers"
    [regions]="regions"
    [projects]="projects"
    [simulations]="simulations"
    (filterChange)="onFilterChange($event)"></app-load-simulation-filter>
  <app-load-simulation-table (loadSimulationEvent)="loadSimulation($event)"></app-load-simulation-table>
</app-header-modal-layout>
